module.exports = __webpack_public_path__ + "img/process-icon-2.9934b301.svg";